import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: any, args: any): any {
    if (!args) {
      return value;
    }

    const regexArgs = args.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(regexArgs, 'gi');
    if (value) {
      const idx = value.search(re);
      const repl = value.substr(idx, args.length);

      return value.replace(re, '<mark>' + repl + '</mark>');
    }
    return value;
  }
}
